import { CommonService } from './../services/common/common.service';
import { Pipe, PipeTransform } from "@angular/core";
import {UserService} from "../services/user/user.service";
@Pipe({
  name: "utcDate"
})
export class UtcDatePipe implements PipeTransform {

  constructor(private userService:UserService,private commonService:CommonService){

  }
  private months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  // transform(value: any, args?: any): any {
  //   let d = new Date(value);
  //   if (!d) {
  //     return "-";
  //   }
  //   let u =
  //     d.getUTCDate() +
  //     " " +
  //     this.months[d.getUTCMonth()] +
  //     " " +
  //     d.getUTCFullYear();

  //     return u;
  // }
  transform(value: any, args?: any): any {
    // console.log("DateTime",value);
    let dateFormat = "";
    if(value){
      let timeFormat = this.getClientTimeZone();
      // dateFormat = this.userService.getOffsetconvertUtc(value,timeFormat);
      dateFormat = this.commonService.getDateConverted(value,timeFormat);
      // dateFormat = this.commonService.getOffsetConverted(value,timeFormat,true);
      // dateFormat = moment(value).format(timeFormat); //moment(value,timeFormat);
    }
    return dateFormat;
  }

  getClientTimeZone():string{
    //get User offset
    let userOff = this.userService.getLoggedInUser();
    return userOff.settings.dateTimeFormat;
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/pipe/utc-date.pipe.ts